import React, { useEffect, useState } from 'react';
import { Button, Col, Modal, Row, Typography } from 'antd';
import { formatTime, isDocumentClassification, isMultiflow } from '../../../lib/util';
import { getAlgorithmValue } from '../../../lib/util/algorithm';
import { LabelGroup } from '../../../common/LabelGroup';
import { Algorithm, Model, Training } from '../../../types';
import { useHistory } from 'react-router';
import { getDataset } from '../../../lib/api/dataset-api';
import { Dataset } from '../../../types/dataset';

const { Text } = Typography;

type Props = {
  trainingCount: null | number;
  mostRecentTraining: null | Training;
  model: Model;
  algorithm: Algorithm;
};

const ModelHeader = (props: Props) => {
  const { trainingCount, mostRecentTraining, model, algorithm } = props;

  const [dataset, setDataset] = useState<Dataset>();

  useEffect(() => {
    const fetchDataset = async () => {
      try {
        if (props.model.datasetId) {
          const fetchedDataset = await getDataset(props.model.datasetId.toString());
          setDataset(fetchedDataset);
        }
      } catch (error) {
        console.error('Error fetching dataset:', error);
      }
    };
    fetchDataset();
  }, [props.model.datasetId]);

  let history = useHistory();
  const showLabels = () => {
    Modal.info({
      title: 'Labels',
      content: <LabelGroup annotationTypes={model && model.info.annotationTypes} />,
    });
  };

  const showClasses = () => {
    Modal.info({
      title: 'Classes',
      content: <LabelGroup annotationTypes={model && model.info.annotationTypes} />,
    });
  };

  const isClassification = isDocumentClassification(algorithm);

  const text = isClassification ? 'Classes' : model.datasetId ? 'Dataset' : 'Labels';

  const goToDataset = async () => {
    if (dataset && model.datasetId) {
      history.push('/projects/' + dataset.project_id + '/datasets/' + dataset.id + '/overview?page=1&size=10');
    }
  };

  return (
    <>
      <Row className="container items-center justify-between">
        <Col className="mr-6 my-2">
          <Text className="mr-3">Type:</Text>
          <Text>{getAlgorithmValue(model.algorithm.name)}</Text>
        </Col>
        <Col className="mr-6 my-2">
          <Text className="mr-3">Trainings:</Text>
          <Text>{trainingCount}</Text>
        </Col>
        {mostRecentTraining && (
          <Col className="mr-6 my-2">
            <Text className="mr-3">Most Recent Training:</Text>
            <Text>{formatTime(mostRecentTraining.timeCreated)}</Text>
          </Col>
        )}
        <Col className="mr-6 my-2">
          <Text className="mr-3">{text}:</Text>
          <Button
            type="link"
            className="p-0"
            onClick={event => {
              if (text === 'Dataset') {
                goToDataset();
              }
              event.preventDefault();
              event.stopPropagation();
              if (isClassification) {
                showClasses();
              } else {
                showLabels();
              }
            }}>
            {text !== 'Dataset' && model.info && model.info.annotationTypes && model.info.annotationTypes.length}
            {text !== 'Dataset' && isClassification ? 'classes' : text !== 'Dataset' ? 'labels' : null}
            {text === 'Dataset' && dataset && dataset.name}
          </Button>
        </Col>
      </Row>
      {isMultiflow(algorithm) && (
        <Row>
          <Col className="mr-6 my-2">
            <Text className="mr-3">Flow:</Text>
            <Text>{model.info.flowName}</Text>
          </Col>
          <Col className="mr-6 my-2">
            <Text className="mr-3">Mode:</Text>
            <Text>{model.info.flowMode}</Text>
          </Col>
          <Col className="mr-6 my-2">
            <Text className="mr-3">Status:</Text>
            <Text>{model.info.active ? 'active' : 'inactive'}</Text>
          </Col>
        </Row>
      )}
    </>
  );
};

export default ModelHeader;
